export const SUPPORTED_COUNTRIES = ['KW', 'EG', 'SA', 'AE', 'QA', 'BH', 'JO'];
